import React from 'react';
import PropTypes from 'prop-types';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMEditMenuTableRow from 'components/dashboard/form/SMEditMenuTableRow';
import reactMixin from 'react-mixin';

class SMUSettingMenuView extends React.Component {
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    this.sizeToFit();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentDidUpdate(prevProps, prevState) {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    this.sizeToFit();
  }
  
  sizeToFit(e) {
    let $navigationTable = $(this.refs.navigationTable);
    $navigationTable.outerHeight(this.navigationTableHeight());
  }
  
  render() {
    let navigationTitles = [I18n.t('dashboard.label_000020'), I18n.t('dashboard.label_000181'), I18n.t('dashboard.label_000500'), I18n.t('dashboard.label_000023'), I18n.t('dashboard.label_000182'), I18n.t('dashboard.label_001200'), I18n.t('dashboard.label_000183')],
        navigationRows = [];
    for (let rowIndex = 0; rowIndex < navigationTitles.length; rowIndex++) {
      navigationRows.push(
        <SMEditMenuTableRow 
          key={rowIndex} 
          title={navigationTitles[rowIndex]} 
          delegate={this.props.delegate} 
          rowIndex={rowIndex} 
          isCurrent={this.props.selectedRowIndex == rowIndex} 
        />
      );
    }
    
    return(
      <div className="dashboard-sidecol fl">
        <h2 className="dashboard-title mt25 mb25 ml20">設定</h2>
        <div ref="navigationTable" className="js-scroller dashboard-sidecol__scrollarea">
          <ul>{navigationRows}</ul>
        </div>
      </div>
    );
  }
}
SMUSettingMenuView.propTypes = {
  delegate: PropTypes.object.isRequired,
  selectedRowIndex: PropTypes.number.isRequired,
};
reactMixin(SMUSettingMenuView.prototype, SMSplitViewMixin);
export default SMUSettingMenuView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/SMUSettingMenuView.jsx